export default "__VITE_ASSET__BhrKGX2l__"